import { useEffect, useState } from "react";
import { getAllObjectsLayer } from "../../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { MapOverlayWidget } from "../../../../widgets/map/mapAddons/mapOverlayWidget";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { useMapURLParams } from "../../../../hooks/map/useMapParams";
import { MapName } from "../../../../stateManagement/reducers/maps/actions";
import { useAuthWeatherStationsService } from "../../../../hooks/auth/useAuthWeatherStationsService";
import { useWeatherStations } from "../../../../hooks/data/useWeatherStations";
import { useWeatherStationsMapLayer } from "../../../../hooks/map/layers/useWeatherStationsMapLayer";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../../../stateManagement/reducers";
import { getObjectsOnVectorLayer } from "src/widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";

export function MapWeatherStations() {
    const dispatch = useDispatch();
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const roadsLayer = getAllObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useAuthWeatherStationsService();
    const { weatherStations, isFetching, isError } = useWeatherStations()
    const weatherStationsLayer = useWeatherStationsMapLayer(weatherStations);

    useEffect(() => {
        if (weatherStationsLayer) {
            setAdditionalLayers([weatherStationsLayer])
        }
    }, [weatherStationsLayer])

    useEffect(() => {
        if (isError) {
            dispatch(showToastMessage({ messageType: "error", messageText: "Ошибка загрузки местоположения метеостанций на карте", windowType: "map" }))
        }
    }, [isError])

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnVectorLayer(event, mapName, additionalLayers[0], map)
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [{ name: 'objectsFind', func: applyMapObjectsFind }];

    return (
        <>
            <ContentHeader title="Метеостанции" objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget
                    additionalLayers={additionalLayers}
                    permanentLayers={permanentLayers}
                    mapEventHandlers={mapEventHandlers}
                />
                <MapOverlayWidget />
            </div>
        </>
    )
}
